import { Link } from "@remix-run/react";
import { motion } from "framer-motion";
import { FaDiscord } from "react-icons/fa";

export type SocialProofStats = {
  totalPlayers: number;
  totalScenarios: number;
  totalPlays: number;
};

const formatCount = (n: number): string => {
  if (n < 1000) return n.toString();
  if (n < 10_000) return `${(n / 1000).toFixed(1)}k`;
  if (n < 1_000_000) return `${Math.round(n / 1000)}k`;
  return `${(n / 1_000_000).toFixed(1)}m`;
};

export const SocialProofStrip = ({ stats }: { stats: SocialProofStats }) => {
  const items = [
    { value: stats.totalPlayers, label: "guys leveling up" },
    { value: stats.totalScenarios, label: "scenarios" },
    { value: stats.totalPlays, label: "plays logged" },
  ];

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="mt-10 rounded-2xl border-1 border-neutral-800 bg-neutral-900/40 p-4"
    >
      <div className="grid grid-cols-3 gap-2 text-center">
        {items.map((item) => (
          <div key={item.label} className="flex flex-col">
            <span className="font-bangers text-2xl text-primary leading-none">
              {formatCount(item.value)}
            </span>
            <span className="text-[10px] font-mono opacity-60 mt-1 leading-tight">
              {item.label}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t-1 border-neutral-800 flex items-center justify-center gap-2 text-xs font-mono opacity-70">
        <span>Daily talk in</span>
        <Link
          to="https://discord.gg/h3usDWEwY8"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-white active:opacity-60"
        >
          <FaDiscord className="text-base" />
          Discord
        </Link>
      </div>
    </motion.section>
  );
};
